import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-general-error',
  templateUrl: './general-error.component.html',
  styleUrls: ['./general-error.component.scss']
})
export class GeneralErrorComponent {
  assetsUrl = environment.assetsUrl;
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/close-icon.svg',
    image: 'close-icon',
    title: 'Lo sentimos, no podemos atender tu solicitud',
    content: 'El sitio se encuentra temporalmente fuera de servicio.'
  };
}
